import React from "react";
import { Quote, Star } from "lucide-react";

const TESTIMONIALS = [
    {
        id: "watchtower-mendez",
        quote: "Watchtower is the first cup of every shift. Clean, bright, nothing bitter — exactly what a 6 a.m. brief calls for.",
        name: "Sgt. R. Mendez",
        role: "Patrol Sergeant · Texas",
    },
    {
        id: "guardian-ortiz",
        quote: "Guardian has that balanced, smooth body we need after a long run. The whole company drinks it — no complaints, just empty pots.",
        name: "Capt. T. Ortiz",
        role: "Fire Captain · Ohio",
    },
    {
        id: "commander-hayes",
        quote: "Commander is the dark, full-bodied cup I want in my hand at 2 a.m. Bold without being burnt. Real coffee.",
        name: "Lt. M. Hayes",
        role: "USMC Veteran",
    },
    {
        id: "watchtower-walsh",
        quote: "Watchtower is my morning ritual. Smooth, clean, never harsh — even on three hours of sleep.",
        name: "K. Walsh",
        role: "EMT-P · Kentucky",
    },
    {
        id: "commander-brooks",
        quote: "Commander has real backbone — dark, smoky, and strong. Exactly the cup I need before a 12-hour shift.",
        name: "Det. J. Brooks",
        role: "Detective · Indiana",
    },
    {
        id: "guardian-doyle",
        quote: "Keeping Guardian in our break room department-wide. Easy favorite across every shift.",
        name: "Chief P. Doyle",
        role: "Police Chief · Illinois",
    },
];

const Testimonials = () => {
    const loop = [...TESTIMONIALS, ...TESTIMONIALS];
    return (
        <section
            id="testimonials"
            data-testid="testimonials-section"
            className="relative py-24 md:py-32 bg-[#0B0E14] overflow-hidden"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 mb-12 md:mb-16">
                <div className="bs-eyebrow">From The Watch</div>
                <h2
                    data-testid="testimonials-title"
                    className="font-anton text-4xl md:text-5xl lg:text-6xl uppercase text-white tracking-wide mt-4 leading-[1.05] max-w-3xl"
                >
                    The People We Roast For{" "}
                    <span className="text-[#004466]">Speak.</span>
                </h2>
            </div>

            <div className="md:hidden max-w-[1400px] mx-auto px-6 grid grid-cols-1 gap-4">
                {TESTIMONIALS.slice(0, 4).map((t, i) => (
                    <Card key={t.id} t={t} idx={i} />
                ))}
            </div>

            <div className="hidden md:block relative">
                <div className="flex bs-marquee-track" style={{ width: "max-content" }}>
                    {loop.map((t, i) => (
                        <div key={`${t.id}-${i}`} className="w-[420px] flex-shrink-0 px-4">
                            <Card t={t} idx={i} />
                        </div>
                    ))}
                </div>
                <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[#0B0E14] to-transparent" />
                <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[#0B0E14] to-transparent" />
            </div>
        </section>
    );
};

const Card = ({ t, idx }) => (
    <div
        data-testid={`testimonial-card-${idx}`}
        className="bs-card p-6 md:p-7 h-full"
    >
        <Quote className="w-6 h-6 text-[#004466] mb-4" />
        <p className="font-body text-slate-200 leading-relaxed text-base md:text-lg">
            "{t.quote}"
        </p>
        <div className="flex items-center gap-1 mt-5">
            {[1, 2, 3, 4, 5].map((n) => (
                <Star
                    key={`star-${n}`}
                    className="w-4 h-4 fill-[#ffffff] text-[#ffffff]"
                />
            ))}
        </div>
    </div>
);

export default Testimonials;
